/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * Countries whose Emergency Alert System (EAS) OSD presentation is explicitly
 * configured. Values match the `easConfiguration.easDisplayMode` enum returned
 * in the branding UI bundle.
 *
 * A country not listed here falls back to the default EAS OSD configuration
 * (United States — top of screen).
 */
export enum EasOsdCountry {
  /** United States — top of screen (default). */
  UnitedStates = "us",

  /** Canada — full-screen (bilingual English / French presentation). */
  Canada = "canada",

  /** El Salvador — bottom of screen. */
  ElSalvador = "elSalvador",

  /** Honduras — bottom of screen. */
  Honduras = "honduras"
}
